import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
class QuoteRequestMapper {
    formatRequest(syms, subscribe, streaming_type) {
        const symbols = syms.map((x) => {
            return { symbol: x };
        });
        const subReq = {
            request: {
                streaming_type: streaming_type,
                data: {
                    symbols,
                },
                formFactor: "W",
                response_format: "json",
                request_type: subscribe ? "subscribe" : "unsubscribe",
                appID: urlConfig.appid,
            },
            echo: {},
        };
        return JSON.stringify(subReq);
    }
}
export default QuoteRequestMapper;
